module.exports = __webpack_public_path__ + "media/images/creator/home/kv@3x-de03ee6082628916fe9361621bcdc570.png";